import Header from 'components/header/Header';
import React from 'react';
import { useGetHeaderButtons } from './hooks';

const ProteinVariantHeader = (props) => {
  const { setShowModal, saveVariants, isDirty, onDiscardButtonClick, isError } = props;
  const saveCancelButtons = useGetHeaderButtons(
    setShowModal,
    saveVariants,
    isDirty,
    onDiscardButtonClick,
    isError,
  );

  return (
    <>
      <Header
        containerStyle={{ height: '100%' }}
        headerButtons={[]}
        isNewTheme={true}
        title={'Create Protein Variant'}
        extendedActionSection={saveCancelButtons}
      />
    </>
  );
};

export default ProteinVariantHeader;
